<script>
import BaseCard from "@/components/BaseCard.vue";
import BaseContent from "./BaseContent.vue";
import BasePill from "./BasePill.vue";
import BaseSubContent from "./BaseSubContent.vue";
import CharacterDomain from "./CharacterDomain.vue";

export default {
    name: "CharacterActiveSkill",
    components: {
        BaseCard,
        CharacterDomain,
        BaseSubContent,
        BaseContent,
        BasePill,
    },
    props: {
        activeSkill: {
            type: Object,
            required: true,
        },
    },
};
</script>

<template>
    <BaseCard class="!gap-0 divide-y divide-green-900/75 !p-0">
        <template #heading>Active Skill</template>

        <BaseContent class="p-4">
            <template #header>{{ activeSkill.name }}</template>
            {{ activeSkill.description }}

            <BaseSubContent v-if="activeSkill.condition" header="condition">
                {{ activeSkill.condition }}
            </BaseSubContent>

            <BaseSubContent v-if="activeSkill.ultimate_atk" header="details">
                <ul class="ml-4 list-disc">
                    <li>
                        Multiplies ATK by
                        <strong
                            >{{
                                activeSkill.ultimate_atk.atk_multiplier
                            }}%</strong
                        >
                    </li>
                    <li v-if="activeSkill.ultimate_atk.multi_target">
                        Targets <strong>all enemies</strong>
                    </li>
                </ul>
            </BaseSubContent>
        </BaseContent>

        <CharacterDomain
            v-if="activeSkill.domain"
            :domain="activeSkill.domain"
            class="p-4"
        />
    </BaseCard>
</template>

<style scoped></style>
